<template>
  <v-container fluid>
    <v-data-table :headers="headers" class="elevation-1" :items="empresas" :loading="loading">
      <template v-slot:top>
        <v-toolbar flat>
          <v-spacer />
          <v-btn
            depressed
            color="accent"
            :to="{ name: 'empresas-formulario', path: 'novo' }"
            v-if="perms.includes('empresas.criar_empresas')"
          >
            <v-icon class="mdi mdi-domain-plus mr-2" />Nova empresa
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.ativo="{ item }">
        <v-icon
          :class="
            item.ativo
              ? 'mdi mdi-checkbox-marked-outline'
              : 'mdi mdi-checkbox-blank-outline'
          "
        />
      </template>
      <template v-slot:item.cnpj="{item}">{{maskCNPJ(item.cnpj)}}</template>
      <template v-slot:item.acoes="{ item }">
        <lista-documentos-dialog
          :title="`Documentos de ${maskCNPJ(item.cnpj)}`"
          :id-proprietario="item.id"
          url-base="empresas"
        />
        <v-btn
          icon
          small
          v-if="perms.includes('empresas.editar_empresas')"
          @click="editar(item.id)"
        >
          <v-icon class="mdi mdi-pencil" small />
        </v-btn>
        <dialog-confirm
          titulo="Deletar empresa"
          texto="Confirma a exclusão?"
          v-if="perms.includes('empresas.excluir_empresas')"
          @confirmar="deletar(item.id)"
        >
          <v-btn icon small text>
            <v-icon class="mdi mdi-delete" small />
          </v-btn>
        </dialog-confirm>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import DialogConfirm from "../components/DialogConfirm";
import ListaDocumentosDialog from "../components/documentos/ListaDocumentosDialog";
import { build } from "../lib/masks";
export default {
  components: { DialogConfirm, ListaDocumentosDialog },
  data() {
    return {
      headers: [
        { text: "CNPJ", value: "cnpj" },
        { text: "Razão social", value: "razao_social" },
        { text: "Fantasia", value: "nome_fantasia" },
        { text: "Ativa", value: "ativo", align: "center" },
        { text: "Ações", value: "acoes", sortable: false, align: "center" }
      ],
      loading: true
    };
  },
  computed: {
    ...mapState({
      perms: state => state.usuarios.usuarioAtivo.permissoes,
      empresas: state => state.empresa.empresas
    })
  },
  methods: {
    async deletar(id) {
      this.loading = true;
      try {
        await this.$store.dispatch("empresa/deletar", id);
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },
    editar(id) {
      this.$router.push({
        name: "empresas-formulario-editar",
        params: { id }
      });
    },
    async listar() {
      this.loading = true;
      try {
        await this.$store.dispatch("empresa/listar");
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },
    maskCNPJ(val) {
      return build.cnpj(val);
    }
  },
  mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Grupo Engeguind"
    });

    this.listar();
  }
};
</script>
